import {
  getBedev2BaseUrl,
  convertRobloxUrlToCurrentEnvironment,
} from '@modules/utilities/constants/baseUrl';
import { getEndpointRiskLevel } from '../../config/endpointRiskLevels';
import { SWAGGER_EXTENSIONS } from './constants';

/**
 * Extracts server URL from OpenAPI/Swagger spec
 */
export const extractServerUrl = (parsedSpec: any): string => {
  // OpenAPI 3.0+ format (preferred)
  if (parsedSpec.servers?.[0]?.url) {
    return parsedSpec.servers[0].url;
  }

  // Swagger 2.0 format (fallback)
  if (parsedSpec.host) {
    const scheme = parsedSpec.schemes?.[0] || 'https';
    const basePath = parsedSpec.basePath || '';
    return `${scheme}://${parsedSpec.host}${basePath}`;
  }

  return '';
};

/**
 * Adds custom properties to a single operation
 */
export const processOperation = (
  operation: any,
  method: string,
  serverUrl: string,
  path: string,
): void => {
  const operationObj = operation;

  // Mark whether operation has supported auth types for "Try it out" (non-apis.* domains)
  operationObj[SWAGGER_EXTENSIONS.TRY_IT_OUT_HAS_SUPPORTED_AUTH_TYPES] =
    !convertRobloxUrlToCurrentEnvironment(serverUrl).includes(getBedev2BaseUrl());

  // Add risk level information to the operation
  operationObj[SWAGGER_EXTENSIONS.TRY_IT_OUT_RISK_LEVEL] = getEndpointRiskLevel(
    method,
    serverUrl,
    path,
  );

  // Add full URL to the operation
  operationObj[SWAGGER_EXTENSIONS.TRY_IT_OUT_URL] = `${serverUrl}${path}`;
};

/**
 * Processes the Swagger specification by adding custom properties to operations
 */
export const processSwaggerSpec = (specStringified: string) => {
  const parsedSpec = JSON.parse(specStringified);
  const serverUrl = extractServerUrl(parsedSpec);

  if (parsedSpec.paths) {
    Object.keys(parsedSpec.paths).forEach((path) => {
      const pathItem = parsedSpec.paths[path];
      Object.keys(pathItem).forEach((method) => {
        const operation = pathItem[method];
        processOperation(operation, method, serverUrl, path);
      });
    });
  }

  return parsedSpec;
};
